/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyPageBlock = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyPageBlock model module.
   * @module model/StrategyPageBlock
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyPageBlock</code>.
   * @alias module:model/StrategyPageBlock
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>StrategyPageBlock</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyPageBlock} obj Optional instance to populate.
   * @return {module:model/StrategyPageBlock} The populated <code>StrategyPageBlock</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('GridXCellStart')) {
        obj['GridXCellStart'] = ApiClient.convertToType(data['GridXCellStart'], 'Integer');
      }
      if (data.hasOwnProperty('GridYCellStart')) {
        obj['GridYCellStart'] = ApiClient.convertToType(data['GridYCellStart'], 'Integer');
      }
      if (data.hasOwnProperty('WidthGridCells')) {
        obj['WidthGridCells'] = ApiClient.convertToType(data['WidthGridCells'], 'Integer');
      }
      if (data.hasOwnProperty('HeightGridCells')) {
        obj['HeightGridCells'] = ApiClient.convertToType(data['HeightGridCells'], 'Integer');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('DashboardBlockID')) {
        obj['DashboardBlockID'] = ApiClient.convertToType(data['DashboardBlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} StrategyDescriptionID
   * @default 0
   */
  exports.prototype['StrategyDescriptionID'] = 0;
  /**
   * @member {Integer} GridXCellStart
   * @default 0
   */
  exports.prototype['GridXCellStart'] = 0;
  /**
   * @member {Integer} GridYCellStart
   * @default 0
   */
  exports.prototype['GridYCellStart'] = 0;
  /**
   * @member {Integer} WidthGridCells
   * @default 0
   */
  exports.prototype['WidthGridCells'] = 0;
  /**
   * @member {Integer} HeightGridCells
   * @default 0
   */
  exports.prototype['HeightGridCells'] = 0;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} DashboardBlockID
   */
  exports.prototype['DashboardBlockID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


